module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABLE")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("F")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm01"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-texta"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm01"
    }
  }, [_c('i', [_vm._v("The Search for WomanSpirit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-texta"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ODDESS")]), _vm._v(": H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERSTORY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-texta"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_c('i', [_vm._v("WomanSpirit – Free")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_vm._v("PART TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-texta"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RANSITION")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-texta"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_c('i', [_vm._v("WomanSpirit – Challenged Threatened")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-texta"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NQUISITION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-texta"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("WomanSpirit – Demonized Burnt to Ashes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-texta"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FTERMATH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-texta"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("WomanSpirit – Rising")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/end01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/end02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/end03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0